import User from '../assets/user.svg?react';
import '../assets/user.svg';
// import Bell from '../assets/bell.svg?react';
import '../assets/bell.svg';
import SignOut from '../assets/sign-out.svg?react';
import '../assets/sign-out.svg';
import Profile from '../assets/profile.svg?react';
import '../assets/profile.svg';
// import Settings from '../assets/settings.svg?react';
import '../assets/settings.svg';
import React, { useState, useRef } from "react";
import { useCurrentUser } from 'web/hooks/useCurrentUser';
import { useCurrentOrganization } from 'web/hooks/useCurrentOrganization';
import { Dropdown } from 'react-daisyui';
// import ArrowDark from './assets/arrow-dark.svg?react';
import ArrowDark from '../assets/arrow-dark.svg?react'
import useToPage from 'web/hooks/useToPage';
import useLogoutFunc from 'web/hooks/useLogoutFunc';
import { Organization } from 'web/model/Organization';
import useClickOutsideCallback from 'web/hooks/useClickOutsideCallback';
const UserAvtar = ({ name, email }: { email: string, name: string }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const toMyProfile = useToPage('/my-profile');
  // const toAccountSettings = useToPage('/account-settings');
  const logout = useLogoutFunc();
  const dropdownRef = useRef<HTMLDivElement>(null);

  useClickOutsideCallback(dropdownRef, () => {
    setDropdownOpen(false);
  });

  return (
    <header className="flex justify-between items-center">
      <div></div>
      <div className="relative flex gap-[8px] items-center">
      <OrganizationPicker />
        {/* <Bell /> */}
        <div
          className="flex items-center space-x-2 cursor-pointer hover:bg-[#EEEEEE]  px-[12px] py-[8px] rounded-[8px]"
          onClick={toggleDropdown}
        >
          <div className="w-[32px] h-[32px] rounded-full bg-[#000] flex items-center justify-center">
            <User />
          </div>
          <div className='ml-[12px]'>
            <p className="text-[14px] font-[600] text-[#171717]">{name}</p>
            <p className="text-[14px] text-[#3C3C3C]">{email}</p>
          </div>
          <svg
            className={`w-[18px] h-[18px] ml-[10px] text-[#171717] transition-transform duration-300 ${dropdownOpen ? "rotate-180" : ""
              }`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </div>
        {dropdownOpen && (
          <div className="absolute right-0 top-[58px] py-[4px] z-20 w-[153px] bg-white rounded-md border border-[#BDBDBD] ring-1 ring-black ring-opacity-5" ref={dropdownRef}>
            <ul>
              <DropdownItem onClick={() => toMyProfile()} onAuxClick={() => toMyProfile()}>
                <Profile /> View profile
              </DropdownItem>
              {/* <DropdownItem onClick={toAccountSettings}>
                <Settings /> Account settings
              </DropdownItem> */}
              <DropdownItem onClick={() => logout()}>
                <SignOut /> Sign out
              </DropdownItem>
            </ul>
          </div>

        )}
      </div>
    </header>
  );
};
export default UserAvtar;

const DropdownItem = ({children, ...props}: React.HTMLAttributes<HTMLLIElement> & {children: React.ReactNode}) => {
  return (
    <li className="pl-[10px] flex gap-[8px] mb-[4px] py-[7.5px] text-[#171717] items-center cursor-pointer" {...props}>
      {children}
    </li>
  )
}

const OrganizationPicker = () => {
    const user = useCurrentUser();
    const {currentOrganization, setCurrentOrganization: _setCurrentOrganization} = useCurrentOrganization();
    const dropdownRef = useRef<HTMLDetailsElement>(null);

    const setCurrentOrganization = (org: Organization) => {
      _setCurrentOrganization(org);
      window.location.reload();
    }

    useClickOutsideCallback(dropdownRef, () => {
      dropdownRef.current?.removeAttribute('open');
    });

    return (
         <Dropdown.Details className='text-center' ref={dropdownRef}>
            <Dropdown.Details.Toggle 
                className='pl-[12px] py-[8px] pr-[20px] border-0 min-h-[36px] leading-[36px] h-[36px] text-[#0D0D0D] font-[600] text-[14px] mx-auto capitalize bg-[#F4F6F8] hover:bg-[#EEEEEE] rounded-[8px]'
            >
                {currentOrganization?.name}
                <ArrowDark 
                    className={`relative right-[-10px]`}
                />
            </Dropdown.Details.Toggle>
            <Dropdown.Menu className='w-full p-0'>
                {user.organizations?.map(org => (
                    <Dropdown.Item key={org.id} onClick={() => setCurrentOrganization(org)} className='py-[10px] border-0 text-[14px] z-20 bg-white hover:!bg-white rounded-md border-[#BDBDBD] ring-1 ring-black ring-opacity-5'>
                        {org.name}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown.Details>
    );
}